"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _react = _interopRequireDefault(require("react"));
var _Footer = require("./Footer.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Footer = function Footer(_ref) {
  var mainUrl = _ref.mainUrl,
    _ref$footerLinks = _ref.footerLinks,
    footerLinks = _ref$footerLinks === void 0 ? [] : _ref$footerLinks,
    year = _ref.year,
    testId = _ref.testId,
    _ref$copyright = _ref.copyright,
    copyright = _ref$copyright === void 0 ? 'Copyright' : _ref$copyright,
    _ref$rights = _ref.rights,
    rights = _ref$rights === void 0 ? 'All rights reserved.' : _ref$rights;
  var classes = (0, _Footer.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: classes.root,
    "data-testid": testId
  }, /*#__PURE__*/_react["default"].createElement("strong", null, copyright, " \xA9 ", year, ' ', /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    href: mainUrl.url
  }, mainUrl.text), "."), /*#__PURE__*/_react["default"].createElement("span", null, "\xA0", rights, footerLinks.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: link.url
    }, "\xA0|\xA0", /*#__PURE__*/_react["default"].createElement("a", {
      target: "_blank",
      href: link.url
    }, link.text));
  })));
};
exports.Footer = Footer;